import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { fetchData } from "../../utils/functions";
import { useParams } from "react-router-dom";
import { ThinTextField } from "../common/GeneralComponent";

const EditHouseholdAssets = ({ householdAssets, onUpdate, DqaApproved, DqaRejected }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();

  const [assets, setAssets] = useState({
    radio: false,
    sewingMachine: false,
    fan: false,
    chair: false,
    watch: false,
    iron: false,
    television: false,
    fridge: false,
    washingMachine: false,
    airCooler: false,
    microwaveOven: false,
    refrigerator: false,
    airConditioner: false,
    waterFilter: false,
    donkeyPump: false,
    bicycle: false,
    motorcycle: false,
    animalDrawnCart: false,
    CarTruckBusVan: false,
    Tractor: false,
    BoatwithMotor: false,
    TractorTrolley: false,
    AutorickshawChingchi: false,
    Computer: false,
    Analog: false,
    TouchAndriod: false,
    femaleCellPhone: undefined,
    ownsAgriculturalLand: undefined,
    Livestock: undefined,
    hasBankAccount: undefined,
    femaleAccount: undefined,
    agriculturalLandAcres: "",
    farming: "",
    // Livestock counts
    cowsCount: "",
    buffaloesCount: "",
    horsesCount: "",
    goatsCount: "",
    sheepCount: "",
    chickensCount: ""
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [isDqaApproved, setIsDqaApproved] = useState(DqaApproved); 
  const [isDqaRejected, setIsDqaRejected] = useState(DqaRejected); 
  const [householdInfoData, setHouseholdInfoData] = useState(null);
  const [dataLoaded, setDataLoaded] = useState(false);

  const assetItems = [
    { id: "radio", label: "Radio" },
    { id: "sewingMachine", label: "Sewing Machine" },
    { id: "fan", label: "Fan" },
    { id: "chair", label: "Chair" },
    { id: "watch", label: "Watch" },
    { id: "iron", label: "Iron" },
    { id: "television", label: "Television" },
    { id: "fridge", label: "Fridge" },
    { id: "washingMachine", label: "Washing Machine" },
    { id: "airCooler", label: "Air Cooler" },
    { id: "microwaveOven", label: "Microwave Oven" },
    { id: "refrigerator", label: "Refrigerator" },
    { id: "airConditioner", label: "Air conditioner" },
    { id: "waterFilter", label: "Water Filter" },
    { id: "donkeyPump", label: "Donkey Pump/Turbine" },
    { id: "bicycle", label: "Bicycle" },
    { id: "motorcycle", label: "Motorcycle / Scooter" },
    { id: "animalDrawnCart", label: "Animal-drawn Cart" },
    { id: "CarTruckBusVan", label: "Car/Truck/Bus/Van" },
    { id: "Tractor", label: "Tractor" },
    { id: "BoatwithMotor", label: "Boat with Motor" },
    { id: "TractorTrolley", label: "Tractor/Trolley" },
    { id: "AutorickshawChingchi", label: "Autorickshaw/Chingchi" },
    { id: "Computer", label: "Computer" },
    { id: "Analog", label: "Cell/Mobile Phone (Analog)" },
    { id: "TouchAndriod", label: "Cell/Mobile Phone (Touch Android)" }
  ];

  const dbValueToBool = (value) => {
    if (value === null || value === undefined || value === "") return undefined;
    if (value === true || value === false) return value;
    if (value === 1 || value === "1" || value === "true") return true;
    if (value === 0 || value === "0" || value === "false") return false;
    return undefined;
  };


  const fetchHouseholdAssets = async () => {
    if (!id) return;
    try {
      const response = await fetchData(
        `householdinformation/${id}`,
        "GET",
        null,
        {},
        {},
        navigate,
        "/household",
        dispatch
      );
      if (response?.data?.household_assets) {
        processAssetData(response.data.household_assets);
      }
    } catch (error) {
      console.error("Error fetching household assets:", error);
    }
  };

  useEffect(() => {
    if (!householdAssets) fetchHouseholdAssets();
  }, [id]);

    useEffect(() => {
    setIsDqaApproved(DqaApproved);
    setIsDqaRejected(DqaRejected);
  }, [DqaApproved]);

  // Process asset data from API/props
  const processAssetData = (data) => {
    if (!data) return;
    const assetData = Array.isArray(data) ? data[0] || {} : data;

    const processedAssets = {
      radio: dbValueToBool(assetData.household_have_radio) ?? false,
      sewingMachine: dbValueToBool(assetData.household_have_sewing_machine) ?? false,
      fan: dbValueToBool(assetData.household_have_fan) ?? false,
      chair: dbValueToBool(assetData.household_have_chair) ?? false,
      watch: dbValueToBool(assetData.household_have_watch) ?? false,
      iron: dbValueToBool(assetData.household_have_iron) ?? false,
      television: dbValueToBool(assetData.household_have_television) ?? false,
      fridge: dbValueToBool(assetData.household_have_fridge) ?? false,
      washingMachine: dbValueToBool(assetData.household_have_washing_machine) ?? false,
      airCooler: dbValueToBool(assetData.household_have_air_cooler) ?? false,
      microwaveOven: dbValueToBool(assetData.household_have_microwave_oven) ?? false,
      refrigerator: dbValueToBool(assetData.household_have_refrigerator) ?? false,
      airConditioner: dbValueToBool(assetData.household_have_air_conditioner) ?? false,
      waterFilter: dbValueToBool(assetData.household_have_water_filter) ?? false,
      donkeyPump: dbValueToBool(assetData.household_have_donkey_pump_turbine) ?? false,
      bicycle: dbValueToBool(assetData.household_have_bicycle) ?? false,
      motorcycle: dbValueToBool(assetData.household_have_motorcycle_scooter) ?? false,
      animalDrawnCart: dbValueToBool(assetData.household_have_animal_drawn_cart) ?? false,
      CarTruckBusVan: dbValueToBool(assetData.household_have_car_truck_bus_van) ?? false,
      Tractor: dbValueToBool(assetData.household_have_tractor) ?? false,
      BoatwithMotor: dbValueToBool(assetData.household_have_boat_with_motor) ?? false,
      TractorTrolley: dbValueToBool(assetData.household_have_tractor_trolley) ?? false,
      AutorickshawChingchi: dbValueToBool(assetData.household_have_autorickshaw_chingchi) ?? false,
      Computer: dbValueToBool(assetData.household_have_computer) ?? false,
      Analog: dbValueToBool(assetData.household_have_cell_phone_analog) ?? false,
      TouchAndriod: dbValueToBool(assetData.household_have_cell_phone_touch_android) ?? false,
      femaleCellPhone: dbValueToBool(assetData.household_have_female_has_cell_phone),
      ownsAgriculturalLand: dbValueToBool(assetData.owns_agricultural_land),
      Livestock: dbValueToBool(assetData.owns_livestock),
      hasBankAccount: dbValueToBool(assetData.has_bank_account),
      femaleAccount: dbValueToBool(assetData.female_has_bank_account),
      agriculturalLandAcres: assetData.acres_agricultural_land || "",
      farming: assetData.food_items_grown || "",
      // Parse livestock counts
      cowsCount: assetData.owns_livestock_cows || "",
      buffaloesCount: assetData.owns_livestock_buffaloes || "",
      horsesCount: assetData.owns_livestock_horses_donkeys_camels_mules || "",
      goatsCount: assetData.owns_livestock_goats || "",
      sheepCount: assetData.owns_livestock_sheep || "",
      chickensCount: assetData.owns_livestock_chickens || ""
    };

    setAssets(processedAssets);
    setErrors({});
    setDataLoaded(true);
  };

  useEffect(() => {
    if (householdAssets) processAssetData(householdAssets);
  }, [householdAssets]);

  const handleAssetChange = (assetName, value) => {
    setAssets((prev) => {
      const newAssets = { ...prev, [assetName]: value };
      
      // Clear related fields when parent field is set to false
      if (assetName === "ownsAgriculturalLand" && value === false) {
        newAssets.agriculturalLandAcres = "";
        newAssets.farming = "";
      }
      
      if (assetName === "Livestock" && value === false) {
        newAssets.cowsCount = "";
        newAssets.buffaloesCount = "";
        newAssets.horsesCount = "";
        newAssets.goatsCount = "";
        newAssets.sheepCount = "";
        newAssets.chickensCount = "";
      }
      
      if (assetName === "hasBankAccount" && value === false) {
        newAssets.femaleAccount = undefined;
      }
      
      return newAssets;
    });
    setErrors((prev) => ({ ...prev, [assetName]: undefined }));
  };

  const handleIntegerInput = (fieldName, value) => {
    // Only allow positive integers
    const numericValue = value.replace(/[^0-9]/g, '');
    setAssets((prev) => ({ ...prev, [fieldName]: numericValue }));
    setErrors((prev) => ({ ...prev, [fieldName]: undefined }));
  };

  const handleTextInput = (fieldName, value) => {
    setAssets((prev) => ({ ...prev, [fieldName]: value }));
    setErrors((prev) => ({ ...prev, [fieldName]: undefined }));
  };

  const validate = () => {
    const e = {};
    const isBool = (v) => v === true || v === false;

    // Female cell phone
    if (!isBool(assets.femaleCellPhone)) {
      e.femaleCellPhone = "Please select Yes or No.";
    }

    // owns agricultural land
    if (!isBool(assets.ownsAgriculturalLand)) {
      e.ownsAgriculturalLand = "Please select Yes or No.";
    } else if (assets.ownsAgriculturalLand === true) {
      // farming field is required when agricultural land is owned
      if (!assets.farming || String(assets.farming).trim() === "") {
        e.farming = "Food items are required when you own agricultural land.";
      }
      
      // acres field validation
      if (assets.agriculturalLandAcres === null || assets.agriculturalLandAcres === undefined || String(assets.agriculturalLandAcres).trim() === "") {
        e.agriculturalLandAcres = "Acres required.";
      } else {
        const acres = Number(assets.agriculturalLandAcres);

        if (isNaN(acres)) {
          e.agriculturalLandAcres = "Enter a valid number.";
        } else if (acres < 1) {
          e.agriculturalLandAcres = "Minimum value is 1 acre.";
        } else if (acres > 300) {
          e.agriculturalLandAcres = "Maximum allowed is 300 acres.";
        }
      }
    }

    // livestock
    if (!isBool(assets.Livestock)) {
      e.Livestock = "Please select Yes or No.";
    } else if (assets.Livestock === true) {
      // At least one livestock count should be provided
      const livestockCounts = [
        assets.cowsCount, assets.buffaloesCount, assets.horsesCount,
        assets.goatsCount, assets.sheepCount, assets.chickensCount
      ];
      
      const hasAnyLivestock = livestockCounts.some(count => 
        count && String(count).trim() !== "" && Number(count) > 0
      );
      
      if (!hasAnyLivestock) {
        e.livestock = "Please provide count for at least one type of livestock.";
      }
    }

    // bank account
    if (!isBool(assets.hasBankAccount)) {
      e.hasBankAccount = "Please select Yes or No.";
    } else if (assets.hasBankAccount === true) {
      // female bank account is required only if household has bank account
      if (!isBool(assets.femaleAccount)) {
        e.femaleAccount = "Please select Yes or No.";
      }
    }

    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!id) {
      toast.error("Household ID is missing");
      return;
    }

    if (!validate()) {
      return;
    }

    setLoading(true);
    try {
      const submitData = { ...assets };

      const response = await fetchData(
        `household-assets-update/${id}`,
        "PUT",
        submitData,
        {},
        {},
        navigate,
        "/household",
        dispatch
      );

      if (response?.success) {
        toast.success("Household assets updated successfully!");
        await onUpdate?.();
      } else {
        toast.error(response?.message || "Failed to update household assets");
      }
    } catch (error) {
      console.error("Update failed:", error);
      toast.error("Failed to update household assets.");
    } finally {
      setLoading(false);
    }
  };

  if (!dataLoaded) {
    return (
      <div className="p-4 bg-white shadow rounded">
        <div className="text-center py-8">
          <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-teal-600"></div>
          <p className="mt-2 text-gray-600">Loading household assets...</p>
        </div>
      </div>
    );
  }

  const Err = (name) =>
    errors?.[name] ? (
      <p className="text-[0.9rem] text-red-600 mt-2">{errors[name]}</p>
    ) : null;

  // Group assets into rows of 3
  const groupedAssets = [];
  for (let i = 0; i < assetItems.length; i += 3) {
    groupedAssets.push(assetItems.slice(i, i + 3));
  }

  return (
    <div className="bg-white">
      {/* <div className="flex justify-between items-center mb-6">
        <div className="flex items-center gap-4">
          {isDqaApproved && (
            <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm font-semibold">
              Approved from DQA
            </span>
          )}
        </div>
      </div> */}

      <div className="flex justify-between items-center mb-3">
        {isDqaApproved && (
          <>
            <h2 className="text-teal-700 text-xl font-semibold">
              Household Assets
            </h2>
            <span className="bg-blue-100 text-blue-800 px-1 py-1 rounded-full text-sm font-semibold">
              Approved from DQA
            </span>
          </>
        )}
        {isDqaRejected && (
          <>
            <h2 className="text-teal-700 text-xl font-semibold">
              Household Assets
            </h2>

            <span className="bg-red-100 text-red-800 px-3 py-1 rounded-full text-sm font-semibold">
              Rejected from DQA
            </span>
          </>
        )}
      </div>

      <form onSubmit={handleSubmit} className="w-full">
        <p className="text-[14px] mb-4">Does your Household have?</p>

        {/* Asset Items in 3-column grid */}
        <div className="space-y-6 mb-6">
          {groupedAssets.map((row, rowIndex) => (
            <div
              key={rowIndex}
              className="grid grid-cols-1 md:grid-cols-3 gap-6"
            >
              {row.map((item) => (
                <div key={item.id}>
                  <label className="mb-2 block text-sm font-medium text-gray-700">
                    {item.label} {!isDqaApproved && !isDqaRejected && <span className="text-red-500">*</span>}
                  </label>
                  <div className="flex items-center gap-4">
                    <label className="flex items-center gap-1">
                      <input
                        type="radio"
                        name={item.id}
                        checked={assets[item.id] === true}
                        onChange={() => handleAssetChange(item.id, true)}
                        className="accent-blue-600"
                        disabled={isDqaApproved || isDqaRejected}
                      />
                      <span className="text-sm text-gray-700">Yes</span>
                    </label>
                    <label className="flex items-center gap-1">
                      <input
                        type="radio"
                        name={item.id}
                        checked={assets[item.id] === false}
                        onChange={() => handleAssetChange(item.id, false)}
                        className="accent-blue-600"
                        disabled={isDqaApproved || isDqaRejected}
                      />
                      <span className="text-sm text-gray-700">No</span>
                    </label>
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>

        {/* Female Cell Phone Section */}
        <div className="mb-6">
          <label className="mb-2 block text-sm font-medium text-gray-700">
            Does any female of the house have Cell Phone?{" "}
            {!isDqaApproved && !isDqaRejected && <span className="text-red-500">*</span>}
          </label>
          <div className="flex items-center gap-4">
            <label className="flex items-center gap-1">
              <input
                type="radio"
                name="femaleCellPhone"
                checked={assets.femaleCellPhone === true}
                onChange={() => handleAssetChange("femaleCellPhone", true)}
                className="accent-blue-600"
                disabled={isDqaApproved || isDqaRejected}
              />
              <span className="text-sm text-gray-700">Yes</span>
            </label>
            <label className="flex items-center gap-1">
              <input
                type="radio"
                name="femaleCellPhone"
                checked={assets.femaleCellPhone === false}
                onChange={() => handleAssetChange("femaleCellPhone", false)}
                className="accent-blue-600"
                disabled={isDqaApproved || isDqaRejected}
              />
              <span className="text-sm text-gray-700">No</span>
            </label>
          </div>
          {Err("femaleCellPhone")}
        </div>

        {/* Agricultural Land Section */}
        <div className="mb-6">
          <label className="mb-2 block text-sm font-medium text-gray-700">
            Does any member of this Household Own any Land that can be used for
            Agriculture? {!isDqaApproved && !isDqaRejected && <span className="text-red-500">*</span>}
          </label>
          <div className="flex items-center gap-4 mb-2">
            <label className="flex items-center gap-1">
              <input
                type="radio"
                name="ownsAgriculturalLand"
                checked={assets.ownsAgriculturalLand === true}
                onChange={() => handleAssetChange("ownsAgriculturalLand", true)}
                className="accent-blue-600"
                disabled={isDqaApproved || isDqaRejected}
              />
              <span className="text-sm text-gray-700">Yes</span>
            </label>
            <label className="flex items-center gap-1">
              <input
                type="radio"
                name="ownsAgriculturalLand"
                checked={assets.ownsAgriculturalLand === false}
                onChange={() =>
                  handleAssetChange("ownsAgriculturalLand", false)
                }
                className="accent-blue-600"
                disabled={isDqaApproved || isDqaRejected}
              />
              <span className="text-sm text-gray-700">No</span>
            </label>
          </div>
          {Err("ownsAgriculturalLand")}

          {assets.ownsAgriculturalLand === true && (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
              <div>
                <ThinTextField
                  value={assets.agriculturalLandAcres}
                  label="How many acres of Agricultural Land do members of this Household Own?"
                  isRequired={true}
                  onChange={(e) => {
                    const newValue = e.target.value.slice(0, 3);
                    handleIntegerInput("agriculturalLandAcres", newValue);
                  }}
                  disabled={isDqaApproved || isDqaRejected}
                />
                {Err("agriculturalLandAcres")}
              </div>

              <div>
                <ThinTextField
                  value={assets.farming}
                  label="What food items (including vegetables) do you grow yourself?"
                  isRequired={true}
                  onChange={(e) => handleTextInput("farming", e.target.value)}
                  disabled={isDqaApproved || isDqaRejected}
                />
                {Err("farming")}
              </div>
            </div>
          )}
        </div>

        {/* Livestock Section */}
        <div className="mb-6">
          <label className="mb-2 block text-sm font-medium text-gray-700">
            Does this Household own any Livestock, Herds, other Farm Animals, or
            Poultry? {!isDqaApproved && !isDqaRejected && <span className="text-red-500">*</span>}
          </label>
          <div className="flex items-center gap-4 mb-2">
            <label className="flex items-center gap-1">
              <input
                type="radio"
                name="Livestock"
                checked={assets.Livestock === true}
                onChange={() => handleAssetChange("Livestock", true)}
                className="accent-blue-600"
                disabled={isDqaApproved || isDqaRejected}
              />
              <span className="text-sm text-gray-700">Yes</span>
            </label>
            <label className="flex items-center gap-1">
              <input
                type="radio"
                name="Livestock"
                checked={assets.Livestock === false}
                onChange={() => handleAssetChange("Livestock", false)}
                className="accent-blue-600"
                disabled={isDqaApproved || isDqaRejected}
              />
              <span className="text-sm text-gray-700">No</span>
            </label>
          </div>
          {Err("Livestock")}
          {Err("livestock")}

          {assets.Livestock === true && (
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
              <div>
                <ThinTextField
                  value={assets.cowsCount}
                  label="How many Cows?"
                  isRequired={false}
                  onChange={(e) =>
                    handleIntegerInput("cowsCount", e.target.value)
                  }
                  disabled={isDqaApproved || isDqaRejected}
                />
              </div>

              <div>
                <ThinTextField
                  value={assets.buffaloesCount}
                  label="How many Buffaloes?"
                  isRequired={false}
                  onChange={(e) =>
                    handleIntegerInput("buffaloesCount", e.target.value)
                  }
                  disabled={isDqaApproved || isDqaRejected}
                />
              </div>

              <div>
                <ThinTextField
                  value={assets.horsesCount}
                  label="How many Horses, donkeys, camels or mules?"
                  isRequired={false}
                  onChange={(e) =>
                    handleIntegerInput("horsesCount", e.target.value)
                  }
                  disabled={isDqaApproved || isDqaRejected}
                />
              </div>

              <div>
                <ThinTextField
                  value={assets.goatsCount}
                  label="How many Goats?"
                  isRequired={false}
                  onChange={(e) =>
                    handleIntegerInput("goatsCount", e.target.value)
                  }
                  disabled={isDqaApproved || isDqaRejected}
                />
              </div>

              <div>
                <ThinTextField
                  value={assets.sheepCount}
                  label="How many Sheep?"
                  isRequired={false}
                  onChange={(e) =>
                    handleIntegerInput("sheepCount", e.target.value)
                  }
                  disabled={isDqaApproved || isDqaRejected}
                />
              </div>

              <div>
                <ThinTextField
                  value={assets.chickensCount}
                  label="How many Chickens?"
                  isRequired={false}
                  onChange={(e) =>
                    handleIntegerInput("chickensCount", e.target.value)
                  }
                  disabled={isDqaApproved || isDqaRejected}
                />
              </div>
            </div>
          )}
        </div>

        {/* Bank Account Section */}
        <div className="mb-6">
          <label className="mb-2 block text-sm font-medium text-gray-700">
            Does any member of this household have an account in a bank?{" "}
            {!isDqaApproved && !isDqaRejected && <span className="text-red-500">*</span>}
          </label>
          <div className="flex items-center gap-4 mb-2">
            <label className="flex items-center gap-1">
              <input
                type="radio"
                name="hasBankAccount"
                checked={assets.hasBankAccount === true}
                onChange={() => handleAssetChange("hasBankAccount", true)}
                className="accent-blue-600"
                disabled={isDqaApproved || isDqaRejected}
              />
              <span className="text-sm text-gray-700">Yes</span>
            </label>
            <label className="flex items-center gap-1">
              <input
                type="radio"
                name="hasBankAccount"
                checked={assets.hasBankAccount === false}
                onChange={() => handleAssetChange("hasBankAccount", false)}
                className="accent-blue-600"
                disabled={isDqaApproved || isDqaRejected}
              />
              <span className="text-sm text-gray-700">No</span>
            </label>
          </div>
          {Err("hasBankAccount")}

          {/* Female Bank Account Section - only show if household has bank account */}
          {assets.hasBankAccount === true && (
            <div className="mt-4">
              <label className="mb-2 block text-sm font-medium text-gray-700">
                Do female members of the house have a separate bank account?{" "}
                {!isDqaApproved && !isDqaRejected && <span className="text-red-500">*</span>}
              </label>
              <div className="flex items-center gap-4 mb-1">
                <label className="flex items-center gap-1">
                  <input
                    type="radio"
                    name="femaleAccount"
                    checked={assets.femaleAccount === true}
                    onChange={() => handleAssetChange("femaleAccount", true)}
                    className="accent-blue-600"
                    disabled={isDqaApproved || isDqaRejected}
                  />
                  <span className="text-sm text-gray-700">Yes</span>
                </label>
                <label className="flex items-center gap-1">
                  <input
                    type="radio"
                    name="femaleAccount"
                    checked={assets.femaleAccount === false}
                    onChange={() => handleAssetChange("femaleAccount", false)}
                    className="accent-blue-600"
                    disabled={isDqaApproved || isDqaRejected}
                  />
                  <span className="text-sm text-gray-700">No</span>
                </label>
              </div>
              {Err("femaleAccount")}
            </div>
          )}
        </div>

        {!isDqaApproved && !isDqaRejected && (
          <div className="mt-8 flex justify-end">
            <button
              type="submit"
              disabled={loading}
              className={`${
                loading ? "bg-gray-400" : "bg-teal-600 hover:bg-teal-700"
              } bg-teal-600 text-white rounded-lg px-4 py-2 hover:bg-teal-700 transition-colors`}
            >
              {loading ? "Updating..." : "Update"}
            </button>
          </div>
        )}
      </form>
    </div>
  );
};

export default EditHouseholdAssets;